import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from 'utils/messageHandler';

const chatSlice = createSlice({
  name: 'permisos',
  initialState: {
    conversations: [],
    conversation: null,
    loading: true,
    conversationsError: null
  },
  reducers: {
    request: state => {
      state.loading = true;
    },
    setConversations: (state, { payload }) => {
      state.conversations = payload;
      state.loading = false;
    },
    setConversation: (state, { payload }) => {
      //console.log(payload.where);
      state.conversation = payload;
      state.loading = false;
    },
    removeConversationLocal: (state, { payload: id }) => {
      state.conversations = state.conversations.filter(c => c.id !== id);
      if (state.conversation?.id === id) state.conversation = null;
      state.loading = false;
    },
    removeMessageLocal: (state, { payload: messageId }) => {
      if (state.conversation?.messages) {
        state.conversation.messages = state.conversation.messages.filter(
          m => m.id !== messageId
        );
      }
      state.loading = false;
    },
    handleError: (state, { payload: { error, message, accessor } }) => {
      state.loading = false;
      state[accessor] = message;
      messageHandler('error', error?.message);
    }
  }
});

export const {
  request,
  setConversation,
  setConversations,
  removeConversationLocal,
  removeMessageLocal,
  handleError
} = chatSlice.actions;
/* const token =
  typeof window !== 'undefined' ? window.localStorage.getItem('token') : null; */
export const getConversations = branchOffices => async dispatch => {
  request();
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_SERVER}/conversations/by-branch-offices`,
      {
        branchOffices
      }
    );

    dispatch(setConversations(data));
  } catch (e) {
    dispatch(
      handleError({
        error: e,
        message:
          'No se pudieron cargar las conversaciones\nPor favor recargue la página',
        accessor: 'conversationsError'
      })
    );
  }
};

export const getConversation = (conversationId, where) => async dispatch => {
  request();

  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_SERVER}/conversations/${conversationId}`
    );

    dispatch(setConversation({ ...data, where }));
  } catch (e) {
    dispatch(
      handleError({
        error: e,
        message:
          'No se pudieron cargar las conversaciones\nPor favor recargue la página',
        accessor: 'conversationsError'
      })
    );
  }
};

export const sendMessage =
  ({ conversationId, message, userId }) =>
  async dispatch => {
    request();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER}/messages`,
        {
          message,
          userId,
          conversationId
        }
      );

      dispatch(setConversation(data.conversation));

      return 'success';
    } catch (e) {
      dispatch(handleError(e));
    }
  };

export const readMessages = (conversationId, isUser) => async dispatch => {
  request();

  try {
    const { data } = await axios.patch(
      `${process.env.REACT_APP_SERVER}/conversations/read/${conversationId}`,
      {
        isUser
      }
    );

    return data.updatedConversation;
  } catch (e) {
    dispatch(handleError(e));
  }
};
export const deleteMessage = messageId => async dispatch => {
  request();
  try {
    await axios.delete(`${process.env.REACT_APP_SERVER}/messages/${messageId}`);
    dispatch(removeMessageLocal(messageId));
    messageHandler('success', 'mensaje Eliminado Exitosamente');

    return 'success';
  } catch (e) {
    if (!e.response) {
      console.log('error:');
    } else {
      dispatch(handleError(e));
    }
  }
};

export const deleteConversation =
  conversationId => async (dispatch, getState) => {
    request();
    try {
      await axios.delete(
        `${process.env.REACT_APP_SERVER}/conversations/${conversationId}`
      );
      dispatch(removeConversationLocal(conversationId));
      const url = new URL(window.location.href);
      const currentCid = url.searchParams.get('cid');
      if (String(currentCid) === String(conversationId)) {
        const next = getState().chat.conversations[0]?.id;
        if (next) url.searchParams.set('cid', String(next));
        else url.searchParams.delete('cid');
        window.history.replaceState({}, '', url.toString());
      }
      messageHandler('success', 'Conversacion Eliminada Exitosamente');

      return 'success';
    } catch (e) {
      if (!e.response) {
        console.log('error:');
      } else {
        dispatch(handleError(e));
      }
    }
  };
export default chatSlice.reducer;
